module.exports = __webpack_public_path__ + "a246d332e147e5ab81892fbced55da7f.svg";